import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/tibesa.scss';
import './scss/wizards.scss';

ReactDOM.render(<App />, document.getElementById('root'));
